/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useQuery } from '@office-start/data-fetching';
import { getQueryKey } from '../getQueryKey';
import { getUserStorageItem } from '../operations/getUserStorageItem';
import { useUserStorageOptions } from './useUserStorageOptions';
export function useUnpersistedUserStorage(storageKey, forceRefresh, remoteAttempts) {
    var options = useUserStorageOptions();
    var queryKey = getQueryKey(storageKey);
    return useQuery(queryKey, function () {
        return getUserStorageItem(storageKey, options, forceRefresh, remoteAttempts).then(function (result) { return ({
            result: result,
            fromPersistence: false,
        }); });
    }, {
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: !!options && !!storageKey,
    });
}
//# sourceMappingURL=useUnpersistedUserStorage.js.map